import { render, staticRenderFns } from "./suspect_matches.vue?vue&type=template&id=07c2e9ef"
import script from "./suspect_matches.vue?vue&type=script&lang=js"
export * from "./suspect_matches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports